export enum EDownloadingStatus {
    ZASTUPOSOBA = 'zastupOsoba',
    DOKLADTOTOZ = 'dokladTotoz',
    ELEKTPODPIS = 'elektPodpis'
}
